module.exports = __webpack_public_path__ + "static/img/197_TO8_2098.299fc88.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/197_TO8_2098.jpg
// module id = FJCd
// module chunks = 0